<template>
  <div id="side-bar">

    <el-menu
        :default-active="$route.path"
            :unique-opened="false"
            class="menu"
            :background-color="this.$root.colorController"
            :text-color="(this.$root.colorController == '#000' ? '#bdbdbd' : '#000')"
            :collapse="isCollapseShow"
            :collapse-transition="false"
            :active-text-color="variables.menuActiveText"
            mode="vertical"
      >
<!-- text-color="#d8d8d8" -->
<!-- :text-color="{color:(this.$root.colorController == '#000' ? '#bdbdbd' : '#000')}" -->

      <span v-if="this.$root.colorController === '#000'">
       <hamburger class="hamburger-container" style="margin:0 0" @toggleClick="isCollapse" />
      </span>

      <span v-else>
        <hamburger-white class="hamburger-container" style="margin:0 0" @toggleClick="isCollapse" />
      </span>


      <menu-item :menu="menu" :col="this.$root.colorController"></menu-item>
    </el-menu>

  </div>

</template>

<script>
  import MenuItem from './MenuItem'

  import Hamburger from '@/components/Hamburger'
  import HamburgerWhite from '@/components/HamburgerWhite'

  import {
    mapGetters
  } from 'vuex'

  import variables from '@/styles/variables.scss'

  export default {
    name: 'LeftMenu',
    data() {
      return {
        isCollapseShow: true,

      }
    },
    components: {
      HamburgerWhite,
      Hamburger,
      MenuItem,
    },
    computed: {

      menu() {
        return this.$store.state.user.menu

      },

      activeMenu() {
        const route = this.$route
        const {
          meta,
          path
        } = route
        // if set path, the sidebar will highlight the path you set
        if (meta.activeMenu) {
          return meta.activeMenu
        }
        return path
      },
      variables() {
        return variables
      },


    },
    methods: {
      toggleSideBar() {
        this.$store.dispatch('app/toggleSideBar')

      },
      isCollapse() {
        this.$root.isActiveApp = !this.$root.isActiveApp
        console.log(this.$root.isActiveApp);
        return this.isCollapseShow = !this.isCollapseShow
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath)
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath)
      }
    }

  }
</script>

<style scoped>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }

  #side-bar {
    width: 201px !important;
  }

  /* 菜单栏高度充满屏幕 */
  #side-bar,
  .menu {
    height: 100%;
  }

  /* 折叠按钮样式*/
  .navbar {
    height: 50px;
    overflow: hidden;
    position: relative;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

    .hamburger-container {
      line-height: 46px;
      height: 100%;
      float: left;
      cursor: pointer;
      transition: background 0.3s;
      -webkit-tap-highlight-color: transparent;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }

  }
</style>
